import React from 'react'
import { cn } from '../../lib/utils'

interface LogoProps {
  className?: string
  containerClassName?: string
  showBackground?: boolean
}

export const Logo: React.FC<LogoProps> = ({ 
  className = "w-8 h-8", 
  containerClassName,
  showBackground = true
}) => {
  const svgContent = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      className={cn("object-contain shrink-0", className)}
      aria-label="Estipana Logo"
    >
      <polygon points="256,60 296,140 216,140" fill="#14B8A6" />
      <polygon points="206,160 306,160 346,240 166,240" fill="#1D3557" />
      <polygon points="156,260 356,260 396,340 116,340" fill="#14B8A6" />
      <polygon points="106,360 406,360 446,440 66,440" fill="#1D3557" />
    </svg>
  )

  if (!showBackground) {
    return svgContent
  }

  return (
    <div className={cn(
      "inline-flex items-center justify-center bg-white dark:bg-white border border-neutral-100/80 rounded-xl p-1 shadow-xs shrink-0 transition-colors",
      containerClassName
    )}>
      {svgContent}
    </div>
  )
}

export default Logo
